"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDropdownDivider;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _HR = _interopRequireDefault(require("../elements/HR"));

var getClasses = function getClasses(className) {
  return (0, _classNames.default)('private-dropdown-divider', className);
};

function UIDropdownDivider(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_HR.default, (0, _extends2.default)({
    distance: "extra-small"
  }, rest, {
    className: getClasses(className)
  }));
}

UIDropdownDivider.displayName = 'UIDropdownDivider';
module.exports = exports.default;